import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * ShareUploadPage - Handles PWA Share Target redirects
 * 
 * When users share photos from WhatsApp, Gallery, or other apps via the Share menu,
 * this page is triggered. Since we're a SPA, we can't directly receive the POST data
 * with files. Instead, we redirect to the upload modal where users can select the
 * files they just saved/shared.
 * 
 * Future enhancement: Use Service Worker to intercept FormData and store files
 * in IndexedDB, then retrieve them in the upload modal.
 */
export default function ShareUploadPage() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('[PWA Share Target] Share detected - redirecting to upload');
    
    // Show a brief message then redirect to upload modal
    const timer = setTimeout(() => {
      navigate('/feed?openUpload=true', { replace: true });
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 to-purple-50">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md text-center">
        <div className="text-6xl mb-4 animate-bounce">📸</div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Opening Upload
        </h2>
        <p className="text-gray-600 mb-4">
          Thanks for sharing to Family Album!
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-primary-500 border-t-transparent"></div>
          <span>Preparing upload...</span>
        </div>
      </div>
    </div>
  );
}

